export const ccpUrl = "https://ejamerica.my.connect.aws/ccp-v2"
export const connectRegion = "us-east-1"


// export const paperFormUrl = "https://7kgnl9fo1j.execute-api.us-west-2.amazonaws.com/dev/"
// export const ssoUrl = "https://fticonsulting.onelogin.com/trust/saml2/http-post/sso/c8eb3c28-b729-4739-8520-d06666501c7f"
// 